<template>
    <span v-if="now && expires">{{ timeToGo }}</span>
</template>

<script>
import { format, add, differenceInSeconds } from "date-fns";

export default {
    data() {
        return {
						secondsToExpiry: -9999,
        }
    },
    props: {
        now: Date,
        expires: Date
    },
    computed: {
        timeToGo: function() {
            if (this.secondsToExpiry > -9999) {
								if (this.secondsToExpiry < 1) {
                                    if (this.$store.getters.receiptContent == null)
                                    {
                                        this.$store.dispatch("updateBasket");
                                    }
									return "";
								}
								return format(add(new Date(0), { seconds: this.secondsToExpiry }), "mm:ss");
            }
            else {
                return "";
            }
        }
    },
    mounted: function() {
        window.setInterval(() => this.secondsToExpiry = differenceInSeconds(this.expires, new Date()), 1000);
    }
}

</script>
